<template>
  <div name="hrms75e-popup-cours" id="hrms75e-popup-cours" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRMS75EC8']['10'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
          <div class="box-body">
            <div class="detail-block">        
             <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC8']['20'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ indexSelected.codcours }} - {{ indexSelected.desc_codcours }}</div>
                </div>
              </div>
            </form>

            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC8']['30'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ data.desc_codcate }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC8']['40'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ data.desc_codtparg }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC8']['50'] }}</label>
                <div class="col-md-6">
                   <div class="detail-text width-100 txtarea-width response-full-width">{{ data.descrs1 }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC8']['60'] }}</label>
                <div class="col-md-6">
                  <div class="input-group margin-b-0">
                    <input class="form-control" readonly v-model="data.amtbudg" />
                    <div class="input-group-addon">{{ labels['HRMS75EC8']['70'] }}</div>
                  </div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC8']['80'] }}</label>
                <div class="col-md-6">
                   <div class="detail-text width-100 txtarea-width response-full-width">{{ data.syncond }}</div>
                </div>
              </div>
            </form>
            </div>       
          </div>    
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hrms75e-popup-cours',
  props: [ 'labels', 'data', 'columns', 'indexSelected' ]
}
</script>

<style lang="scss">
	#settime {
	  animation-duration: 1s;
	}
	.hrms75e-popup-edit-box {
		border-top: 1px solid #EDEDED;
		padding: 5px;
		margin: 5px 0 0 0;
	}
	
</style>


// WEBPACK FOOTER //
// popupCours.vue?624f23b9